var map = {
	"./Report-Preview.png": "WpJ5",
	"./attachment.png": "QdU8",
	"./c-logo.png": "jcE1",
	"./c-logo2.png": "LQLe",
	"./c-logo3.png": "y8Es",
	"./circle.png": "0hXx",
	"./dkl.png": "J6B7",
	"./dkl_favicon.png": "jv52",
	"./favicon-16x16.png": "8qof",
	"./favicon-32x32.png": "d+Ze",
	"./favicon.png": "oXF7",
	"./gpt.png": "b0kK",
	"./img-01.jpg": "zoCZ",
	"./logo.png": "T/0B",
	"./placeholder.jpg": "4O5/",
	"./reports.png": "VNxu",
	"./s-logo.png": "804T",
	"./system-user.png": "wBju",
	"./task.png": "0B4d",
	"./user.jpg": "3jdf",
	"./video-call.jpg": "qsrA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qj58";